import { render, staticRenderFns } from "./RegisterTutor.vue?vue&type=template&id=fe30aa80&"
import script from "./RegisterTutor.vue?vue&type=script&lang=js&"
export * from "./RegisterTutor.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTutor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports